import { Navigate, type RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';
import Home from '../pages/home/page';
import Login from '../pages/login/page';
import Register from '../pages/register/page';
import Pricing from '../pages/pricing/page';
import ProtectedRoute from '../components/layout/ProtectedRoute';
import GuestRoute from '../components/layout/GuestRoute';
import SiteProviderLayout from '../components/layout/SiteProviderLayout';
import ConsoleLayout from '../components/layout/ConsoleLayout';
import AppLayout from '../components/layout/AppLayout';
import Dashboard from '../pages/dashboard/page';
import Realtime from '../pages/dashboard/realtime/page';
import Sources from '../pages/dashboard/sources/page';
import Pages from '../pages/dashboard/pages/page';
import Geo from '../pages/dashboard/geo/page';
import Engines from '../pages/dashboard/engines/page';
import Keywords from '../pages/dashboard/keywords/page';
import Visitors from '../pages/dashboard/visitors/page';
import Env from '../pages/dashboard/env/page';
import Spiders from '../pages/dashboard/spiders/page';
import Hourly from '../pages/dashboard/hourly/page';
import Logs from '../pages/dashboard/logs/page';
import Entry from '../pages/dashboard/entry/page';
import Exit from '../pages/dashboard/exit/page';
import Hosts from '../pages/dashboard/hosts/page';
import Referrers from '../pages/dashboard/referrers/page';
import Social from '../pages/dashboard/social/page';
import Sites from '../pages/sites/page';
import About from '../pages/legal/about';
import Terms from '../pages/legal/terms';
import Privacy from '../pages/legal/privacy';
import Forgot from '../pages/forgot/page';
import NewSite from '../pages/sites/new/page';
import SiteDetail from '../pages/sites/detail/page';
import Account from '../pages/account/page';
import ApiSettings from '../pages/api-settings/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/pricing',
    element: <Pricing />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/terms',
    element: <Terms />,
  },
  {
    path: '/privacy',
    element: <Privacy />,
  },
  {
    element: <GuestRoute />,
    children: [
      {
        path: '/login',
        element: <Login />,
      },
      {
        path: '/register',
        element: <Register />,
      },
      {
        path: '/forgot',
        element: <Forgot />,
      },
    ],
  },
  {
    element: <ProtectedRoute />,
    children: [
      {
        element: <SiteProviderLayout />,
        children: [
          {
            element: <ConsoleLayout />,
            children: [
              {
                path: '/sites',
                element: <Sites />,
              },
              {
                path: '/sites/new',
                element: <NewSite />,
              },
              {
                path: '/sites/:id',
                element: <SiteDetail />,
              },
              {
                path: '/api-settings',
                element: <ApiSettings />,
              },
              {
                path: '/api',
                element: <Navigate to="/api-settings" replace />,
              },
              {
                path: '/account',
                element: <Account />,
              },
            ],
          },
          {
            element: <AppLayout />,
            children: [
              {
                path: '/dashboard',
                element: <Dashboard />,
              },
              {
                path: '/dashboard/realtime',
                element: <Realtime />,
              },
              {
                path: '/dashboard/sources',
                element: <Sources />,
              },
              {
                path: '/dashboard/pages',
                element: <Pages />,
              },
              {
                path: '/dashboard/geo',
                element: <Geo />,
              },
              {
                path: '/dashboard/engines',
                element: <Engines />,
              },
              {
                path: '/dashboard/keywords',
                element: <Keywords />,
              },
              {
                path: '/dashboard/referrers',
                element: <Referrers />,
              },
              {
                path: '/dashboard/social',
                element: <Social />,
              },
              {
                path: '/dashboard/visitors',
                element: <Visitors />,
              },
              {
                path: '/dashboard/env',
                element: <Env />,
              },
              {
                path: '/dashboard/spiders',
                element: <Spiders />,
              },
              {
                path: '/dashboard/hourly',
                element: <Hourly />,
              },
              {
                path: '/dashboard/logs',
                element: <Logs />,
              },
              {
                path: '/dashboard/entry',
                element: <Entry />,
              },
              {
                path: '/dashboard/exit',
                element: <Exit />,
              },
              {
                path: '/dashboard/hosts',
                element: <Hosts />,
              },
            ],
          },
        ],
      },
    ],
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
